// The audio download's entry points, shared by the startup screen (shell/AudioGate.tsx) and
// Asetukset → Ääni → "Äänet laitteelle" (listen/OfflineAudio.tsx), so both plan the same files into
// the same caches and fetch them the same way (shell/audio-preload.ts). The download's code (the
// lists, the caches) is its own chunk: the start-up JS stays as it was.
import type { Gathered, PreloadProgress, PreloadResult } from './audio-preload';
import { preloadEnabled, type PreloadItem } from './audio-preload-plan';

export interface AudioPreloadDeps {
  enabled: () => boolean;
  gather: () => Promise<Gathered>;
  room: (bytes: number) => Promise<{ fits: boolean; free?: number }>;
  run: (todo: readonly PreloadItem[], onProgress: (p: PreloadProgress) => void, signal: AbortSignal) => Promise<PreloadResult>;
  online: () => boolean;
}

const load = () => import('./audio-preload');

export const audioPreloadDeps: AudioPreloadDeps = {
  enabled: () => preloadEnabled(),
  gather: () => load().then((m) => m.gatherPlan()),
  room: (bytes) => load().then((m) => m.roomFor(bytes)),
  run: (todo, onProgress, signal) => load().then((m) => m.runInBrowser(todo, onProgress, signal)),
  online: () => navigator.onLine,
};
